import { render, staticRenderFns } from "./CurriculumResources.vue?vue&type=template&id=34992162&"
import script from "./CurriculumResources.vue?vue&type=script&lang=js&"
export * from "./CurriculumResources.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumResources.vue?vue&type=style&index=0&id=34992162&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports